// getLeft, getScrollLeft, getWidth
export function getLeft(id) {
    const ele = document.getElementById(id);
    if (ele) {
        return ele.getBoundingClientRect().left;
    }
    return 0;
}
export function getWidth(id) {
    const ele = document.getElementById(id);
    if (ele) {
        return ele.getBoundingClientRect().width;
    }
    return 0;
}
export function getScrollLeft(id) {
    const ele = document.getElementById(id);
    if (ele) {
        return ele.scrollLeft;
    }
    return 0;
}
